export default __webpack_public_path__ + "static/media/journey2.3f950a78.jpg";